import script from "./BaseSelectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelectInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseSelectInput.vue?vue&type=style&index=0&id=ddff0d74&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddff0d74"]])

export default __exports__